// src/components/padrekko/qc/completionCounts.js
//
// Remediation-completion tally over a list of findings. Moved verbatim out of
// CompletionCountsBar.jsx so QcCountsSummary can share it: a component file that
// also exports a function breaks React fast refresh. One definition, two users.

export function countCompletion(findings) {
  const c = { completed: 0, not_completed: 0, pending: 0, total: 0 };
  for (const f of findings ?? []) {
    const s = f.completion_status ?? "pending";
    if (s === "completed" || s === "not_completed" || s === "pending") c[s] += 1;
    c.total += 1;
  }
  return c;
}
